import React, {useState} from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import PageHeading from "../../../../Components/PageHeading";
import UserInfo from "../Component/UserInfo";
import UserSecurity from "../Component/UserSecurity";

const UserProfile = () => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    return (
        <div className="card">
            <PageHeading title={"Profile"} />
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Info" leftIcon={"pi pi-pw pi-user mr-2"} >
                   <UserInfo activeIndex={activeIndex}/>
                </TabPanel>
                <TabPanel header="Security" leftIcon={"pi pi-pw pi-lock mr-2"}>
                    <UserSecurity/>
                </TabPanel>

            </TabView>
        </div>
    )
};

export default UserProfile;